import { call, put, takeLatest } from "redux-saga/effects";
import { 
    setOrderChatbotAnalytics, 
    setOrderChatbotAnalyticsLoader, 
    setOrderChatbotAnalyticsError,
    setChatbotConversations,
    setChatbotConversationsLoader,
    setChatbotConversationsError
} from "../actionCreators/orderChatbotAnalyticsActionCreator";
import { getOrderChatbotAnalyticsService, getChatbotConversationsService } from "../services/orderChatbotAnalyticsService";
import { GET_ORDER_CHATBOT_ANALYTICS, GET_CHATBOT_CONVERSATIONS } from "../actionTypes/orderChatbotAnalyticsActionTypes";
import { toast } from "react-hot-toast";

function* _getOrderChatbotAnalytics(_data: any) {
    try {
        yield put(setOrderChatbotAnalyticsLoader(true));
        const { data } = yield call(getOrderChatbotAnalyticsService, _data.payload);
        yield put(setOrderChatbotAnalyticsLoader(false));
        
        if (data.status === true) {
            yield put(setOrderChatbotAnalytics(data.data));
            _data.callback && _data.callback(data);
        } else {
            yield put(setOrderChatbotAnalyticsError(data.message || "Failed to fetch analytics"));
            _data.callback && _data.callback(data);
        }
    } catch (err: any) {
        yield put(setOrderChatbotAnalyticsLoader(false));
        yield put(setOrderChatbotAnalyticsError(err.message || "Something went wrong"));
        console.log("_getOrderChatbotAnalytics: exceptionError: ", err);
        toast.error("Something went wrong while fetching analytics.");
    }
}

function* _getChatbotConversations(_data: any) {
    try {
        yield put(setChatbotConversationsLoader(true));
        const { data } = yield call(getChatbotConversationsService, _data.payload);
        yield put(setChatbotConversationsLoader(false));
        
        if (data.status === true) {
            yield put(setChatbotConversations(data.data));
            _data.callback && _data.callback(data);
        } else {
            yield put(setChatbotConversationsError(data.message || "Failed to fetch conversations"));
            _data.callback && _data.callback(data);
        }
    } catch (err: any) {
        yield put(setChatbotConversationsLoader(false));
        yield put(setChatbotConversationsError(err.message || "Something went wrong"));
        console.log("_getChatbotConversations: exceptionError: ", err);
        toast.error("Something went wrong while fetching conversations.");
    }
}

function* orderChatbotAnalyticsSaga() {
    yield takeLatest(GET_ORDER_CHATBOT_ANALYTICS, _getOrderChatbotAnalytics);
    yield takeLatest(GET_CHATBOT_CONVERSATIONS, _getChatbotConversations);
}

export default orderChatbotAnalyticsSaga;